
export const CxColor = {

    // Standard
    blue        : '#2196F3',
    red         : '#F44336',
    green       : '#4CAF50',
    black       : '#000000',

    // Soft Pastel Tones (Gentle Contrast)
    pastelBlue  : '#AEC6CF',
    pastelOrange: '#FFC107',
    pastelRed   : '#FF7043',

    // Cool Tones (Professional & Calm)
    softBlue    : '#64B5F6',
    softPurple  : '#9575CD',
    softRed     : '#E57373',

    // Grayscale Approach (Minimal Contrast)
    lightGray   : '#e0e0e0',  // Lightest gray
    mediumGray  : '#BDBDBD',  // Mid-tone gray
    darkGray    : '#757575',  // Darkest gray

    // scales
    grayScale   : ['#90A4AE', '#A0B5C3', '#B0C4C8', '#C0D4D0', '#D0E4D8'],
    tealScale   : ['#80CBC4', '#4DB6AC', '#0097A7', '#66BB6A', '#43A047'],
};

export const CxAppColor = {
    weekday   : 'inherit',
    saturday  : CxColor.softBlue,
    sunday    : CxColor.softRed,

    capa      : [...CxColor.tealScale, CxColor.softBlue, CxColor.softRed],
    emptyCapa : [...Array(5).fill(CxColor.darkGray), CxColor.softBlue, CxColor.softRed]
};

export const CxStatusColor = {
    Pending : CxColor.blue,
    Success : CxColor.green,
    Error   : CxColor.red
};

export const CxSeverityColor = {
    Info    : "primary",    // blue (default)
    Success : "success",    // green
    Warning : "warning",    // orange
    Error   : "error",      // red
    Delete  : "error"       // red (same as Error but for destructive actions)
};
